import React from 'react';
import MuiTextField, { TextFieldProps } from '@material-ui/core/TextField';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    verticalAlign: 'baseline',
    padding: 2,
  },
  inputMultiline: {
    padding: '0 !important',
  },
  inputRoot: {
    backgroundColor: theme.palette.grey[200],
    padding: '6px 10px',
  },
}));

const TextField = (props: TextFieldProps) => {
  const classes = useStyles();

  return (
    <MuiTextField
      size="small"
      variant="outlined"
      {...props}
      className={clsx(classes.root, props.className)}
      InputProps={{
        ...props.InputProps,
        classes: {
          ...props.InputProps?.classes,
          multiline: clsx(
            classes.inputMultiline,
            props.InputProps?.classes?.multiline,
          ),
        },
      }}
      inputProps={{
        ...props.inputProps,
        className: clsx(classes.inputRoot, props.inputProps?.className),
      }}
    />
  );
};

export default TextField;
